<template>
  <div class="modal-backdrop" v-if="show">
    <div class="modal">
      <form>
          <h5 class="description">Type</h5>
          <div class="content">
            <label class="btn" v-for="type in types"  :for="type.value " :key="type.id" :class="{ active: type.text == Type}">
              <svg xmlns="http://www.w3.org/2000/svg" width="15.61" height="12.627" viewBox="0 0 15.61 12.627" v-if="type.text == Type">
                <path id="Icon_open-check" data-name="Icon open-check" d="M12.746,0,11.374,1.432,5.846,6.96,4.236,5.409,2.8,3.977,0,6.781,1.432,8.213,4.415,11.2l1.372,1.432L7.218,11.2l6.96-6.96L15.61,2.8,12.746,0Z" fill="#fff"/>
              </svg>
              {{type.text}}
              <input class="radio" :id="type.value" type="radio" @change="typesvalues" :value="type.text" v-model="Type"/>
            </label>
          </div>
        <h5 class="description">Topologie</h5>
        <div class="content">
          <label class="btn" v-for="topologie in topologies"  :for="topologie.value " :key="topologie.id" :class="{ active: topologie.value == Topologie}" 
          :style="[topologie.value === 0 ? {'flex': '0.8'} : {'flex': '0.2'}]">
          <svg xmlns="http://www.w3.org/2000/svg" width="15.61" height="12.627" viewBox="0 0 15.61 12.627" v-if="topologie.value == Topologie">
                <path id="Icon_open-check" data-name="Icon open-check" d="M12.746,0,11.374,1.432,5.846,6.96,4.236,5.409,2.8,3.977,0,6.781,1.432,8.213,4.415,11.2l1.372,1.432L7.218,11.2l6.96-6.96L15.61,2.8,12.746,0Z" fill="#fff"/>
              </svg>
            {{topologie.text}} 
          <input class="radio" :id="topologie.value" type="radio"  @change="typesvalues" :value="topologie.value" v-model="Topologie"/>
        </label>
        </div>
        <div class="row">
          <div class="col1">
            <button type="button" class="btn" @click="change">Valider</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
//import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  mounted(){
    if(this.type.value == 0) {
      this.Type = this.types[0].text
    }
    else {
      this.Type = this.type.text
    }
  },
  data() {
    return {
      Type:'Tous',
      Topologie:null,
      types:[
        {text:'Tous',value:5},
        {text:'Appartement',value:6},
        {text:'Maison',value:7}
      ],
      topologies:[
        {value:0, text:'Studio et T1'},
        {value:1, text:'T2'},
        {value:2, text:'T3'},
        {value:3, text:'T4'},
        {value:4, text:'T5'}],
    };
  },
  props: {
    show: {
      type: Boolean
    },
    type: {
      type: Object
    },
    typologie: {
      type: Object
    },
  },
  methods: {
    change() {
      this.$emit("change", {type: this.Type, typologie: this.Topologie});
    },
    typesvalues(){
      this.$emit("types", {type: this.Type, typologie: this.Topologie});
    }
  },
  watch: {
    show: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler: function(show) {
        if (show) {
          //desactive scroll in body
          //document.body.style.setProperty("overflow", "hidden");
        } else {
          document.body.style.removeProperty("overflow");
        }
      },
    },
    type(value) {
      if(value.value == 0) {
        this.Type = this.types[0].text
      }
      else {
        this.Type = value.text
      }
    },
    typologie(value) {
      if(value == null){
        this.Topologie = null
      } else {
        this.Topologie = value[0].value
      }
    },
  },
  computed: {},
};
</script>
<style scoped lang="scss">
.modal-backdrop {
  position: absolute;
  .modal {
    width: 100%;
    background-color: #f2fdff;
    border-radius: 3px;
    padding: 15px;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11);
    margin-top: 15px;
    .description {
       margin: 0px;
      margin-bottom: 20px;
      color: #22ABC5;
      font-size: 15px;
      font-weight: normal;
    }
    .content{
      margin-bottom: 10px;
      display: flex;
      .btn {
        margin: 5px;
        padding: 10px;
        border: 1px solid #22abc5;
        border-radius: 5px;
        color: #ffffff;
        background-color: #22abc5;
        font-family: Metropolis;
        font-size: 15px;
        &.active {
          border: 1px solid #ff8c00;
          color: #ffffff;
          background-color: #ff8c00;
          display: flex;
        }
        .radio {
          display: none;
        }
        &:hover {
          cursor: pointer;
        }
      }
    }
    .btn {
      width: 100%;
      border-radius: 5px;
      border: none;
      color: white;
      background-color: #22abc5;
      padding: 12px;
      outline: 0;
      margin-top: 15px;
      font-family: Metropolis;
      font-size: 15px;
      &:focus {
        border: none;
        background-color: #ff8c00;
      }
      &:hover {
        cursor: pointer;
      }
      
    }
    
  }
}
@media screen and (max-width: 768px) {
  .modal-backdrop {
  position: initial;
  }
}
@media screen and (max-width: 375px) {
  .modal-backdrop {
    .modal{
    width: 150px;
    .content{
      .btn{
        height: 10px;
        /* width: 150px; */
        margin: 5px;
        padding: 2px;
        border: 1px solid #c3b4b4;
        border-radius: 10%;
        color: #c3b4b4;
        background-color: white;
        margin: 1px;
        font-family: 'Ubuntu', sans-serif;
      }
    }
  }
  }
}

</style>
